import { useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "../styles/Filters.css";
import { fetchAllTripsDropdown } from "../store/Slices/dropdownSlice";
import Select from "./Select";

const TripIdFilterDropdown = ({
  filterName = "tripFilter",
  searchFilters,
  setSearchFilters,
  closeFilter,
  columnName = "Trip ID",
  alignRight = false,
  setWrapperRef,
  isMulti = true,
}) => {
  const dispatch = useDispatch();
  const tripsData = useSelector(
    (state) => state.dropdowns?.allTripsDropdownData || [],
  );
  const searchLoading = useSelector((state) => state.dropdowns?.loading || false);
  const debounceRef = useRef(null);

  useEffect(() => {
    dispatch(fetchAllTripsDropdown());
    return () => {
      if (debounceRef.current) clearTimeout(debounceRef.current);
    };
  }, [dispatch]);

  const handleInputChange = (inputValue) => {
    if (debounceRef.current) clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(() => {
      dispatch(fetchAllTripsDropdown(inputValue?.trim() || ""));
    }, 400);
    return inputValue;
  };

  const formattedOptions = useMemo(
    () =>
      (tripsData || []).map((opt) => ({
        label: opt?.label || String(opt?.value ?? opt?.id ?? ""),
        value: opt?.value ?? opt?.id,
      })),
    [tripsData],
  );

  const rawValue = searchFilters?.[filterName]?.value;
  const initialValues = Array.isArray(rawValue)
    ? rawValue
    : rawValue !== undefined && rawValue !== null && rawValue !== ""
      ? [rawValue]
      : [];

  const initialSelected = formattedOptions.filter((opt) =>
    initialValues.some((v) => String(v) === String(opt.value)),
  );

  const [selectedOptions, setSelectedOptions] = useState(initialSelected);

  const handleApply = () => {
    if (!selectedOptions || selectedOptions.length === 0) {
      setSearchFilters((prev = {}) => {
        const updated = { ...prev };
        delete updated[filterName];
        return updated;
      });
    } else {
      const selectedValues = selectedOptions.map(
        (opt) => Number(opt.value) || opt.value,
      );
      setSearchFilters((prev = {}) => ({
        ...prev,
        [filterName]: {
          filter_type: isMulti ? "one_of" : "equal_to",
          value: isMulti ? selectedValues : selectedValues[0],
        },
      }));
    }
    if (closeFilter) closeFilter();
  };

  return (
    <div
      className={`filter_wrapper${alignRight ? " filter_wrapper_align_right" : ""}`}
      ref={setWrapperRef}
    >
      <Select
        label={`Select ${columnName}`}
        placeholder="Search..."
        options={formattedOptions}
        loading={searchLoading}
        value={isMulti ? selectedOptions : selectedOptions[0] || null}
        onChange={(opts) => {
          if (isMulti) {
            setSelectedOptions(opts || []);
          } else {
            setSelectedOptions(opts ? [opts] : []);
          }
        }}
        onInputChange={handleInputChange}
        isMulti={isMulti}
        isSearch={true}
      />
      <div className="filter_buttons mt-3">
        <button type="button" onClick={closeFilter} className="btn-cancel">
          Cancel
        </button>
        <button type="button" onClick={handleApply} className="btn-apply">
          Apply
        </button>
      </div>
    </div>
  );
};

export default TripIdFilterDropdown;
